module.exports = {
  recaptchaSiteKey: "6LcQCSkaAAAAABsO9V16zziigfkCXkM_xTTpJ3z6"
};
